import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import zhHk from "./locales/zh-HK.json";
import zhCN from "./locales/zh-CN.json";
import { DEFAULT_APP_LANGUAGE } from "../types/language";

const resources = {
  "en": { translation: en },
  "zh-HK": { translation: zhHk },
  "zh-CN": { translation: zhCN },
} as const;

const storedLanguage = localStorage.getItem('language-storage');
const appLanguage = storedLanguage ? JSON.parse(storedLanguage).state.appLanguage : DEFAULT_APP_LANGUAGE;

// let initialized = false;

// export function getI18nInstance() {
//   if (!initialized) {
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: appLanguage,
    fallbackLng: DEFAULT_APP_LANGUAGE,
    interpolation: { escapeValue: false },
    returnNull: false,
  });
//     initialized = true;
//   }
//   return i18n;
// }

export default i18n;